import type { RawSourceMap } from "source-map-js";

let cachedMapFileName: string;
export function getSourcemapName() {
    return cachedMapFileName ??= document.head.innerHTML.match(/assets\/index-.*?\.js/)?.[0] + ".map";
}

export type TraceEngine = "V8" | "Unknown" | "JavaScriptCore" | "SpiderMonkey";
export function getStackFormat(stack: string): TraceEngine {
    if (/\s*at /.test(stack)) return "V8";
    if (stack.includes("native code")) return "JavaScriptCore";
    return "Unknown";
}

export async function parseStackTrace(stack: string, mapFile: string, filter: boolean = false) {
    let rawSourceMap: RawSourceMap;
    try {
        rawSourceMap = await ((await fetch(mapFile)).json());
    } catch {
        //TODO: Better error handling
        return null;
    }

    const stackFormat = getStackFormat(stack);
    console.log("stackFormat: ", stackFormat);

    // Only ever needed once something has already gone wrong, so keep the consumer
    // out of the initial bundle.
    const { SourceMapConsumer } = await import("source-map-js");
    const consumer = new SourceMapConsumer(rawSourceMap);

    let parsedStack: string;
    if (stackFormat === "V8") {
        parsedStack = stack.split('\n').map(line => {
            const match = line.match(/at .* \((.*):(\d+):(\d+)\)/);
            if (!match) return line;
            const [_, file, lineNum, colNum] = match;
            const pos = consumer.originalPositionFor({
                line: parseInt(lineNum),
                column: parseInt(colNum),
            });
            return `at ${pos.source}:${pos.line}:${pos.column} (${pos.name || ''})`;
        }).join('\n');
    } else {
        parsedStack = stack.split('\n').map(line => {
            const match = line.match(/^.*@(.*):(\d+):(\d+)/);
            if (!match) return line;
            const [_, file, lineNum, colNum] = match;
            const pos = consumer.originalPositionFor({
                line: parseInt(lineNum),
                column: parseInt(colNum),
            });
            return `at ${pos.source}:${pos.line}:${pos.column} (${pos.name || ''})`;
        }).join('\n');
    }

    if (filter) return parsedStack.split('\n').filter(line => line.includes('src/')).join('\n');
    return parsedStack;
}